import React, {createContext, useReducer, useContext, useState} from 'react';
import {View, StyleSheet, TouchableHighlight} from 'react-native';
import PropTypes from 'prop-types';

import {Calendar, SelectMonth, SelectTime} from './components/index';
import {utils} from '../utils';
import {moderateScale} from '../../../tools/Scaling';

const options = {
    backgroundColor: '#fff',
    textHeaderColor: '#212c35',
    textDefaultColor: '#2d4150',
    selectedTextColor: '#fff',
    mainColor: '#61dafb',
    textSecondaryColor: '#7a92a5',
    borderColor: 'rgba(122, 146, 165, 0.1)',
    defaultFont: 'System',
    headerFont: 'System',
    textFontSize: 15,
    textHeaderFontSize: 17,
    headerAnimationDistance: 100,
    daysAnimationDistance: 200,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'set':
            return {...state, ...action};
        case 'toggleMonth':
            return {...state, monthOpen: !state.monthOpen};
        case 'toggleTime':
            return {...state, timeOpen: !state.timeOpen};
        default:
            throw new Error('Unexpected action');
    }
};

const CalendarContext = createContext();

const useCalendar = () => {
    const contextValue = useContext(CalendarContext);
    return contextValue;
};

const DatePicker = props => {


    const calendarUtils = new utils(props);
    const contextValue = {
        ...props,
        reverse: props.reverse === 'unset' ? !props.isGregorian : props.reverse,
        options: {...options, ...props.options},
        utils: calendarUtils,
        state: useReducer(reducer, {
            activeDate: props.current || calendarUtils.getToday(),
            selectedDate: props.selected
                ? calendarUtils.getFormated(calendarUtils.getDate(props.selected))
                : '',
            monthOpen: props.mode === 'monthYear',
            timeOpen: props.mode === 'time',
        }),
    };
    // const [contextValue, setContextValue] = useState({
    //     ...props,
    //     reverse: props.reverse === 'unset' ? !props.isGregorian : props.reverse,
    //     options: {...options, ...props.options},
    //     utils: calendarUtils,
    //     state: useReducer(reducer, {
    //         activeDate: props.current || calendarUtils.getToday(),
    //         selectedDate: props.selected
    //             ? calendarUtils.getFormated(calendarUtils.getDate(props.selected))
    //             : '',
    //         monthOpen: props.mode === 'monthYear',
    //         timeOpen: props.mode === 'time',
    //     }),
    // });
    const [minHeight, setMinHeight] = useState(340);
    const [minWidth, setMinWidth] = useState(320);
    const style = styles(contextValue.options);

    const renderBody = () => {
        switch (contextValue.mode) {
            default:
            case 'datepicker':
                return (
                    <React.Fragment>
                        <Calendar />
                        <SelectMonth/>
                        <SelectTime/>
                    </React.Fragment>
                );
            case 'calendar':
                return (
                    <React.Fragment>
                        <Calendar selected={props.selected} />
                        <SelectMonth/>
                    </React.Fragment>
                );
            case 'monthYear':
                return <SelectMonth/>;
            case 'time':
                return <SelectTime/>;
        }
    };

    return (
        props.isVisibleDatePicker && <CalendarContext.Provider value={contextValue}
        >
            <View
                style={props.onBackdropPress&&{
                    position: 'absolute', top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    zIndex: 99999,
                }}>
                {
                    props.onBackdropPress&&  <TouchableHighlight
                        // disabled={true}
                        style={[

                            {
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                alignContent: 'center',
                                alignItems: 'center',
                                justifyContent: 'center',

                                // height:"100%",
                                // width:"100%",

                                top: 0,
                                bottom: 0,
                                right: 0,
                                left: 0,
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                // zIndex: 9900
                            },

                        ]} onPress={props.onBackdropPress}>
                        <View/>

                    </TouchableHighlight>
                }

                <View
                    style={[style.container, {minHeight, minWidth}, props.style]}
                    onLayout={({nativeEvent}) => {
                        setMinHeight(nativeEvent.layout.width * 0.9 + 55);
                        // setMinWidth(nativeEvent.layout.width * 0.5 + 55)
                    }}>
                    {renderBody()}
                </View>
            </View>
        </CalendarContext.Provider>
    );
};

const styles = theme =>
    StyleSheet.create({
        container: {
            //  backgroundColor: theme.backgroundColor,
            //  backgroundColor: "#ee4d16",
            position: 'relative',
            width: '100%',
            maxWidth: moderateScale(300),
            overflow: 'hidden',
            alignSelf: 'center',
        },
    });

const optionsShape = {
    backgroundColor: PropTypes.string,
    textHeaderColor: PropTypes.string,
    textDefaultColor: PropTypes.string,
    selectedTextColor: PropTypes.string,
    mainColor: PropTypes.string,
    textSecondaryColor: PropTypes.string,
    borderColor: PropTypes.string,
    defaultFont: PropTypes.string,
    headerFont: PropTypes.string,
    textFontSize: PropTypes.number,
    textHeaderFontSize: PropTypes.number,
    headerAnimationDistance: PropTypes.number,
    daysAnimationDistance: PropTypes.number,
};
const modeArray = ['datepicker', 'calendar', 'monthYear', 'time'];
const minuteIntervalArray = [1, 2, 3, 4, 5, 6, 10, 12, 15, 20, 30, 60];

DatePicker.defaultProps = {
    onSelectedChange: () => null,
    onSelectedDateFinal: () => null,
    onMonthYearChange: () => null,
    onTimeChange: () => null,
    onDateChange: () => null,
    current: '',
    selected: '',
    minimumDate: '',
    maximumDate: '',
    selectorStartingYear: 0,
    selectorEndingYear: 3000,
    disableDateChange: false,
    isGregorian: true,
    configs: {},
    reverse: 'unset',
    options: {},
    mode: 'datepicker',
    minuteInterval: 5,
    style: {},
};

DatePicker.propTypes = {
    onSelectedChange: PropTypes.func,
    onSelectedDateFinal: PropTypes.func,
    onMonthYearChange: PropTypes.func,
    onTimeChange: PropTypes.func,
    onDateChange: PropTypes.func,
    current: PropTypes.string,
    selected: PropTypes.string,
    minimumDate: PropTypes.string,
    maximumDate: PropTypes.string,
    selectorStartingYear: PropTypes.number,
    selectorEndingYear: PropTypes.number,
    disableDateChange: PropTypes.bool,
    isGregorian: PropTypes.bool,
    configs: PropTypes.object,
    reverse: PropTypes.oneOf([true, false, 'unset']),
    options: PropTypes.shape(optionsShape),
    mode: PropTypes.oneOf(modeArray),
    minuteInterval: PropTypes.oneOf(minuteIntervalArray),
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export {DatePicker, CalendarContext, useCalendar};
